import gql from "graphql-tag";

const attachmentTypeMutations = {


    createAttachmentType: gql`
        mutation CreateAttachmentType($name: String, $priority: Int, $color: String, $auto_select_by: String) {
            createAttachmentType(name: $name, priority: $priority, color: $color, auto_select_by: $auto_select_by) {
                id,
                name,
                priority,
                color,
                auto_select_by
            }
        }
    `,
    updateAttachmentType: gql`
        mutation UpdateAttachmentType($id: ID!, $name: String, $priority: Int, $color: String, $auto_select_by: String) {
            updateAttachmentType(id: $id, name: $name, priority: $priority, color: $color, auto_select_by: $auto_select_by) {
                id,
                name,
                priority,
                color,
                auto_select_by
            }
        }
    `,
};

export default attachmentTypeMutations;